import { render, staticRenderFns } from "./materialsOfIndentity.vue?vue&type=template&id=092398e1&scoped=true"
import script from "./materialsOfIndentity.vue?vue&type=script&lang=js"
export * from "./materialsOfIndentity.vue?vue&type=script&lang=js"
import style0 from "./materialsOfIndentity.vue?vue&type=style&index=0&id=092398e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092398e1",
  null
  
)

export default component.exports